(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nukken-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nk-faq__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var answer = this.nextElementSibling;
      var icon = this.querySelector('.nk-faq__icon');

      document.querySelectorAll('.nk-faq__question').forEach(function(b) {
        b.setAttribute('aria-expanded', 'false');
        b.nextElementSibling.hidden = true;
        b.querySelector('.nk-faq__icon').textContent = '+';
        b.closest('.nk-faq__item').classList.remove('nk-faq__item--open');
      });

      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        answer.hidden = false;
        icon.textContent = '—';
        this.closest('.nk-faq__item').classList.add('nk-faq__item--open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
